import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PageHeader1 from "../../components/common/PageHeader1";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
// import st from "./DynamicForm.module.scss";

import _ from "lodash";
import { DataGrid } from "@mui/x-data-grid";
import { GetPostListApi , handleDeletePost} from "../../services/Posts";


function PostList() {
  const navigate = useNavigate();

 

  const [isLoading, setIsLoading] = useState(true);
  const [postList, setPostList] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const [page, setPage] = useState(0); // DataGrid ke liye 0-based hota hai
  const [pageSize, setPageSize] = useState(100);
  const [searchText, setSearchText] = useState("");


  const { reset } = useForm();


 

  const columns = () => [
    {
      field: "sno",
      headerName: "S.No.",
      width: 80,
    },
    {
      field: "postBy",
      headerName: "Post By",
      width: 200,
      renderCell: (params) => {
        const user = params.row?.adminId || params.row?.userId;
        return (
          <div>
            <strong>{user?.first_name || "Unknown"}</strong>
            <div style={{ fontSize: 12, color: "#666" }}>{user?.email}</div>
          </div>
        );
      },
    },
    {
      field: "text",
      headerName: "Content",
      width: 250,
    },
    {
      field: "images",
      headerName: "Images",
      width: 150,
      renderCell: (params) =>
        params.row.images && params.row.images.length > 0 ? (
          <img
            src={params.row.images[0].url}
            alt="post"
            style={{
              width: 60,
              height: 60,
              objectFit: "cover",
              borderRadius: 8,
            }}
          />
        ) : (
          <span>No Image</span>
        ),
    },
    {
      field: "videos",
      headerName: "Videos",
      width: 150,
      renderCell: (params) =>
        params.row.videos && params.row.videos.length > 0 ? (
          <video
            src={params.row.videos[0].url}
            width={80}
            height={60}
            controls
          />
        ) : (
          <span>No Video</span>
        ),
    },
    {
      field: "likeCount",
      headerName: "Likes",
      width: 100,
    },
    {
      field: "commentCount",
      headerName: "Comments",
      width: 120,
    },
    {
      field: "createdAt",
      headerName: "Created At",
      width: 180,
      renderCell: (params) =>
        new Date(params.row.createdAt).toLocaleString(),
    },
    {
      field: "action",
      headerName: "Action",
      width: 150,
      renderCell: (params) => (
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            onClick={() => navigate(`/edit-post/${params.row._id}`)}
          >
            <i className="icofont-ui-edit"></i>
          </button>
          <button
            type="button"
            className="btn btn-outline-danger btn-sm"
            onClick={() => handleDeletePost(params.row._id, getPostList)}
           
          >
            <i className="icofont-ui-delete"></i>
          </button>
        </div>
      ),
    },
  ];
  async function getPostList(pageNum, limit) {
    setIsLoading(true);
    try {
      const response = await GetPostListApi(pageNum + 1, limit);
      const { data, pagination } = response;
      setPostList(
        data?.map((item, i) => ({
          ...item,
          id: item._id, // datagrid ke liye unique id
          sno: i + 1,
        })) || []
      );
      setRowCount(pagination?.total || 0);
    } catch (error) {
      console.error("Error fetching post data:", error);
      toast.error("Failed to load posts");
    } finally {
      reset();
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getPostList(page, pageSize);
  }, [page, pageSize]);

  const filteredPosts = postList.filter((post) => {
    if (!searchText) return true;

    const text = searchText.toLowerCase();
    const user = post.userId || post.adminId || {};
    const userMatch =
      (user.first_name?.toLowerCase().includes(text) ||
        user.last_name?.toLowerCase().includes(text) ||
        user.email?.toLowerCase().includes(text)) ?? false;

    const textMatch = post.text?.toLowerCase().includes(text);
    const likesMatch = !isNaN(Number(text)) ? post.likeCount >= Number(text) : false;
    const postDate = new Date(post.createdAt);
    const formattedPostDate = `${postDate.getMonth() + 1}/${postDate.getDate()}/${postDate.getFullYear()}`; // MM/DD/YYYY
  
    const dateMatch = formattedPostDate.includes(searchText);

    return userMatch || textMatch || likesMatch || dateMatch;
  });


  return (
    <div className="body d-flex py-lg-3 py-md-2">
      <div className="container-xxl">
        <PageHeader1
          pagetitle="Post Information"
          modalbutton={() => (
            <div className="col-auto d-flex w-sm-100">
              <button
                type="button"
                className="btn btn-primary btn-set-task w-sm-100"
                onClick={() => navigate("/create-post")}
              >
                <i className="icofont-plus-circle me-2 fs-6"></i>Add Post
              </button>
            </div>
          )}
        />
        <div className="row mb-3">
          <div className="col-md-6">
            <input
              type="text"
              className="form-control"
              placeholder="Search by user, topic, likes, date..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
        </div>
        <div className="row clearfix g-3">
          <div className="col-sm-12 mt-3">
            <div className="card">
              <div className="card-body">
              <DataGrid
                  rows={filteredPosts}
                  columns={columns()}
                  loading={isLoading}
                  paginationMode="client"
                  rowCount={filteredPosts.length}
                  page={page}
                  pageSize={pageSize}
                  onPageChange={(newPage) => setPage(newPage)}
                  onPageSizeChange={(newSize) => {
                    setPageSize(newSize);
                    setPage(0); // reset to first page
                  }}
                  rowsPerPageOptions={[8, 10, 25, 50]}
                  sx={{ border: "none" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );


}
export default PostList;
